import React from 'react';
import { Switch, Route } from 'react-router';
import NavBar from './Components/Common/NavBar/NavBar';
import Footer from './Components/Common/Footer/Footer';
import Service from './Components/Service/Service.jsx';
import Company from './Components/Company/Company';
import Index from './Components/HomePage/Home';
import HeadQuarterGraduate from './Components/Hiring/HeadQuarterGraduate';
import TokyoGraduate from "./Components/Hiring/TokyoGraduate";
import RecruitHR from './Components/HR/RecruitHR';
import Recruit from './Components/Recruit/Recruit';
import MidEngineer from './Components/Hiring/MidEngineer';
import './App.css';
import './assets/css/fonts.css';
import Contact from './Components/Contact/Contact';
import Programmer from './Components/Hiring/Programmer';
import Privacy from './Components/Privacy/Privacy';
import News from './Components/News/News.jsx';
import RecruitForm from './Components/RecruitForm/RecruitForm';
import LandingPage from './Components/LandingPage/LandingPage';
import ErrorPage from './Components/ErrorPage/ErrorPage';


export const PublicRoute = ({ component: Component, ...rest }) => {
  return (
    <Route {...rest} component={(props) => (
      <div>
        <NavBar /> {/* ALWAYS VISIBLE */}
        <div className="whole-container">
          <Component {...props} />
        </div>
        <Footer /> {/* ALWAYS VISIBLE */}
      </div>
    )}
    />
  )
};
export const PrivateRoute = ({ component: Component, ...rest }) => {
  return (
    <Route
      {...rest}
      component={(props) => (<Component {...props} />)}
    />
  );
};
function App() {
  return (
    <React.Fragment>
      {/* <NavBar /> */}
      <Switch>
        {
        /* In this area you would define the routes of the project 
        Syntax: <Route path="/The path of the component" component="componentName">
        EX: <Route path="/" component={Index}
      */}

        <PublicRoute path="/recruit/mid-level-programmer" component={Programmer} />
        <PublicRoute path="/recruit/mid-level-engineer" component={MidEngineer} />
        <PublicRoute path="/recruit/headquarter" component={HeadQuarterGraduate} />
        <PublicRoute path="/recruit/tokyo" component={TokyoGraduate} />
        <PublicRoute path="/recruit-form" component={RecruitForm} />
        <PublicRoute path="/privacy-policy" component={Privacy} />
        <PublicRoute path="/news/:id?" component={News} />
        {/* <PublicRoute path="/news/:id" render={(props) => <NewsPost {...props} />} /> */}
        <PrivateRoute path="/lp" component={LandingPage} />
        <PublicRoute path="/contact" component={Contact} />
        <PublicRoute path="/people" component={RecruitHR} />
        <PublicRoute path="/recruit" component={Recruit} />
        <PublicRoute path="/service" component={Service} />
        <PublicRoute path="/company" component={Company} />
        <PublicRoute exact path="/" component={Index} />
        <PrivateRoute path="*" component={ErrorPage} />

      </Switch>
      {/* <Footer /> */}
    </React.Fragment >
  );
}

export default App;
